/* 首页 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/home',
    component: layoutComponent,
    isOnlyOneLevel: false,
    meta: {
      title: 'menu.home',
      icon: 'el-icon-ali-Home',
      breadcrumb: true
    },
    children: [
      {
        path: '/home/index',
        name: 'tooladmin',
        component: () => import('@/views/homes/index.vue'),
        meta: {
          title: 'menu.homes.toolManagerHome',
          isOnlyOneLevel: true
        }
      },
      {
        path: '/home/companyManager',
        name: 'companyManager',
        component: () => import('@/views/homes/companyManager.vue'),
        meta: {
          title: 'menu.homes.companyManagerHome',
          isOnlyOneLevel: true
        }
      },
      {
        path: '/home/projectManager',
        name: 'projectManager',
        component: () => import('@/views/homes/projectManager.vue'),
        meta: {
          title: 'menu.homes.projectManagerHome',
          isOnlyOneLevel: true
        }
      },
      {
        path: '/home/patentManager',
        name: 'patentManager',
        component: () => import('@/views/homes/patentManager.vue'),
        meta: {
          title: 'menu.homes.countryManagerHome',
          isOnlyOneLevel: true
        }
      }

    ]
  }
]
